import { Icon } from "./Icon";

export function StatusLabel({ status }: { status: string }) {
  const uncertainty = status === "DEVELOPING" || status === "EARLY REPORTING";
  const disputed = status === "DISPUTED";
  return (
    <span className={`status-label ${uncertainty ? "status-label--uncertain" : ""} ${disputed ? "status-label--disputed" : ""}`}>
      <Icon name={uncertainty || disputed ? "alert" : "check"} size={22} />
      {status}
    </span>
  );
}
